var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTransactionSourceOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m625 637.5h-125c-20.75 0-37.5 16.75-37.5 37.5s16.75 37.5 37.5 37.5h62.5v12.5c0 20.75 16.75 37.5 37.5 37.5s37.5-16.75 37.5-37.5v-13.75c56-6.25 100-53.5 100-111.25 0-62-50.5-112.5-112.5-112.5h-50c-20.75 0-37.5-16.75-37.5-37.5s16.75-37.5 37.5-37.5h125c20.75 0 37.5-16.75 37.5-37.5s-16.75-37.5-37.5-37.5h-62.5v-12.5c0-20.75-16.75-37.5-37.5-37.5s-37.5 16.75-37.5 37.5v13.75c-56 6.25-100 53.5-100 111.25 0 62 50.5 112.5 112.5 112.5h50c20.75 0 37.5 16.75 37.5 37.5s-16.75 37.5-37.5 37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1075 187.5h-950c-34.5 0-62.5 28-62.5 62.5v550c0 34.5 28 62.5 62.5 62.5h387.5v75h-62.5c-20.75 0-37.5 16.75-37.5 37.5s16.75 37.5 37.5 37.5h300c20.75 0 37.5-16.75 37.5-37.5s-16.75-37.5-37.5-37.5h-62.5v-75h387.5c34.5 0 62.5-28 62.5-62.5v-550c0-34.5-28-62.5-62.5-62.5zm-462.5 750h-25v-75h25zm450-150h-925v-525h925z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactionSourceOnline);
export default __webpack_public_path__ + "static/media/icon-transaction-source-online.28b3ee3afc1bde1948b7df54fa7a676a.svg";
export { ForwardRef as ReactComponent };